import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=ab5decb0&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
import style0 from "./Form.vue?vue&type=style&index=0&id=ab5decb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5decb0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnForm: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-form.vue').default})
